"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverAllocationPopupWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var reactstrap_1 = require("reactstrap");
var journey_model_1 = require("@athena-portal/journey-model");
var DriverAllocationPopupWidget = /** @class */ (function (_super) {
    __extends(DriverAllocationPopupWidget, _super);
    function DriverAllocationPopupWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.toggleModalCb = function (cb) {
            _this.setState({ showPopup: false }, function () {
                var _a;
                _this.props.engine.setJourneyState((_a = {}, _a["showConfirmationPopup"] = _this.state.showPopup, _a));
                if (cb) {
                    cb();
                }
            });
        };
        _this.toggleModal = function () {
            _this.toggleModalCb();
        };
        _this.navigateToNextPage = function () {
            var _a;
            _this.props.engine.setJourneyState((_a = {}, _a["showConfirmationPopup"] = false, _a));
            _this.props.engine.navigate(_this.navigateToPage, true);
        };
        _this.renderPopup = function () {
            var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: function () { return _this.toggleModal(); } });
            var journeyState = _this.props.engine.getJourneyState();
            return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: journeyState["showConfirmationPopup"], toggle: _this.toggleModal, backdrop: "static", children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: _this.toggleModal, close: closeBtn, children: (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium", children: "Drivers summary" }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light", children: _this.renderDriversSummary() }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsxs)("div", { className: "w-100 d-flex flex-column justify-content-between", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Button, { className: "my-2 w-100", color: "btn btn-primary btn-next-no-arrow", onClick: _this.navigateToNextPage, children: "All OK, all drivers allocated" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(reactstrap_1.Button, { className: "my-2 w-100", color: "btn btn-white", onClick: function () { return _this.toggleModalCb(function () { return window.scrollTo(0, 0); }); }, children: "Allocate more drivers" }) })] }) })] }));
        };
        _this.renderDriversSummary = function () {
            var interaction = _this.props.interaction;
            return interaction.vehicles.map(function (vehicle) {
                return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("p", { children: ["Drivers for ", vehicle.make, ", ", vehicle.model, " (", vehicle.registrationNumber, ")"] }), (0, jsx_runtime_1.jsx)("ul", { className: "drivers-summary-bullet-points", children: _this.renderAllocatedDrivers(vehicle, interaction) })] }));
            });
        };
        _this.renderAllocatedDrivers = function (vehicle, interaction) {
            var allDrivers = [interaction.policyHolder].concat(interaction.additionalDrivers || []);
            var allDriverPersonIds = allDrivers.map(function (person) { return person.personId; });
            var allocatedDrivers = [];
            vehicle.driverIds.forEach(function (id) {
                allDriverPersonIds.forEach(function (driverId) {
                    if (id === driverId) {
                        var driverIndex = allDriverPersonIds.indexOf(driverId);
                        var driver = allDrivers[driverIndex];
                        allocatedDrivers.push((0, jsx_runtime_1.jsxs)("li", { children: [driver.firstName, " ", driver.lastName] }));
                    }
                });
            });
            return allocatedDrivers;
        };
        _this.navigateToPage = _this.getSetting("navigateToPage");
        var journeyState = _this.props.engine.getJourneyState();
        _this.state = {
            showPopup: journeyState["showConfirmationPopup"] || false
        };
        _this.props.engine.setJourneyState((_a = {},
            _a["showConfirmationPopup"] = _this.state.showPopup,
            _a));
        return _this;
    }
    DriverAllocationPopupWidget.prototype.renderInputField = function () {
        var journeyState = this.props.engine.getJourneyState();
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: journeyState["showConfirmationPopup"] && this.renderPopup() }));
    };
    DriverAllocationPopupWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "navigateToPage", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], DriverAllocationPopupWidget);
    return DriverAllocationPopupWidget;
}(plugin_journey_1.QuestionWidgetBase));
exports.DriverAllocationPopupWidget = DriverAllocationPopupWidget;
//# sourceMappingURL=DriverAllocationPopupWidget.js.map